module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 11 20",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }